module.exports = __webpack_public_path__ + "img/dreamer-sky.413ffbb2.jpg";